'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
import { z } from 'zod/mini';
import { CampaignSliderWithFiltersProps } from '@/types/amplience';
import SliderFilters from '@/components/Slider/SliderFilters';
import { getModuleBackgroundStyles } from '@/utility/getModuleBackgroundStyles';
import { SliderHeader } from '../../Slider/SliderHeader';
import { CampaignSliderContent } from '../CampaignSliderContent';
const filterValueSchema = z.pipe(z.string(), z.transform(label => label.toLowerCase().replace(/\s+/g, '-')));
export default function CampaignSliderWithFilters(t0) {
  const $ = _c(27);
  const {
    content,
    className,
    isLazyLoadingOff
  } = t0;
  let t1;
  if ($[0] !== content.filters) {
    t1 = content.filters.map(_temp);
    $[0] = content.filters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const filters = t1;
  const [activeFilterValue, setActiveFilterValue] = useState(filters[0]?.value ?? "");
  let t2;
  if ($[2] !== activeFilterValue || $[3] !== filters) {
    let t3;
    if ($[5] !== activeFilterValue) {
      t3 = f => f.value === activeFilterValue;
      $[5] = activeFilterValue;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = filters.find(t3);
    $[2] = activeFilterValue;
    $[3] = filters;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const activeFilter = t2;
  let t3;
  if ($[7] !== content.backgroundColor) {
    t3 = getModuleBackgroundStyles(content.backgroundColor);
    $[7] = content.backgroundColor;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    bgClass,
    isBackgroundBlack,
    textColor
  } = t3;
  if (!activeFilter) {
    return null;
  }
  const t4 = `${className} ${bgClass}`;
  let t5;
  if ($[9] !== content.heading || $[10] !== content.showAllLink || $[11] !== textColor) {
    t5 = <SliderHeader heading={content.heading} showAllLink={content.showAllLink} className={textColor} />;
    $[9] = content.heading;
    $[10] = content.showAllLink;
    $[11] = textColor;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== activeFilter.value || $[14] !== filters || $[15] !== isBackgroundBlack || $[16] !== textColor) {
    t6 = <SliderFilters filters={filters} activeFilter={activeFilter.value} onFilterChange={setActiveFilterValue} className={textColor} isBackgroundBlack={isBackgroundBlack} />;
    $[13] = activeFilter.value;
    $[14] = filters;
    $[15] = isBackgroundBlack;
    $[16] = textColor;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== activeFilter || $[19] !== content.backgroundColor || $[20] !== isLazyLoadingOff) {
    t7 = activeFilter && <CampaignSliderContent key={activeFilter.value} items={activeFilter.items} cardVariant={activeFilter.cardVariant} backgroundColor={content.backgroundColor} isLazyLoadingOff={isLazyLoadingOff} />;
    $[18] = activeFilter;
    $[19] = content.backgroundColor;
    $[20] = isLazyLoadingOff;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7) {
    t8 = <section className={t4}>{t5}{t6}{t7}</section>;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}
function _temp(filter) {
  return {
    label: filter.label,
    value: filterValueSchema.parse(filter.label),
    items: filter.items,
    cardVariant: filter.cardVariant
  };
}